import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { COMPANIES, CONTACT } from "@/lib/data";
import eseSmall from "@/assets/brand/ese_light_logo.webp";
import zrmLogo from "@/assets/brand/zrm_mark_color.png";
import lhgLogo from "@/assets/brand/lhg_mark_color.png";

export default function Family() {
  return (
    <>
      <section className="bg-cream grain pt-36 pb-20 md:pt-48 md:pb-28 relative">
        <div className="container-editorial relative z-10 max-w-4xl">
          <Reveal>
            <p className="eyebrow text-amber-deep mb-8 flex items-center gap-3">
              <span className="w-10 h-px bg-amber-deep" /> One Advisor, Three Brands
            </p>
          </Reveal>
          <h1 className="font-serif font-bold text-5xl md:text-7xl lg:text-8xl text-blue leading-[0.98] tracking-tight">
            <MaskLines lines={["A family of"]} delay={0.1} />
            <MaskLines lines={["companies."]} className="italic text-amber-deep" delay={0.26} />
          </h1>
          <Reveal delay={0.5}>
            <p className="font-body text-lg text-charcoal/75 mt-8 max-w-2xl leading-relaxed">
              Logan Hunter Group leads the whole journey; Exit Strategy Experts is the flagship
              destination; Zia Risk Management protects the value being built along the way.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-cream pb-24 md:pb-32">
        <div className="container-editorial space-y-6">
          {COMPANIES.map((c, i) => {
            const flagship = c.key === "ese";
            const to = c.key === "ese" ? "/services/exit-and-sell" : c.key === "zia" ? "/zia" : "/services";
            const label = c.key === "ese" ? "Explore the Exit Engagement" : c.key === "zia" ? "Explore Zia Risk Management" : "Explore the Journey";
            return (
              <Reveal key={c.key} delay={i * 0.08}>
                <div
                  className={`relative grid md:grid-cols-[0.4fr_0.6fr] gap-8 md:gap-12 p-10 md:p-14 border transition-colors duration-500 ${
                    flagship
                      ? "bg-blue text-cream border-amber/30 grain"
                      : "bg-cream text-blue border-blue/12 hover:border-blue/30"
                  }`}
                >
                  <div className="relative z-10">
                    <p className={`eyebrow mb-5 ${flagship ? "text-amber-bright" : "text-amber-deep"}`}>
                      {c.role}
                    </p>
                    {flagship ? (
                      <div className="bg-cream p-3 inline-block mb-4">
                        <img src={eseSmall} alt="Exit Strategy Experts" className="h-14 w-auto" />
                      </div>
                    ) : null}
                    {c.key === "zia" ? (
                      <img src={zrmLogo} alt="Zia Risk Management" className="h-20 w-auto mb-4" />
                    ) : null}
                    {c.key === "lhg" ? (
                      <img src={lhgLogo} alt="Logan Hunter Group" className="h-24 w-auto mb-4" />
                    ) : null}
                    <h2 className={`font-serif font-bold text-4xl md:text-5xl leading-tight ${flagship ? "text-cream" : "text-blue"}`}>
                      {c.name}
                    </h2>
                  </div>
                  <div className="relative z-10 flex flex-col justify-center">
                    <p className={`font-body text-lg leading-relaxed ${flagship ? "text-cream/75" : "text-charcoal/70"}`}>
                      {c.line}
                    </p>
                    <Link
                      to={to}
                      data-testid={`family-link-${c.key}`}
                      className={`mt-6 inline-flex items-center gap-2 eyebrow text-[0.62rem] w-fit link-underline transition-colors ${
                        flagship ? "text-amber-bright hover:text-cream" : "text-blue hover:text-amber-deep"
                      }`}
                    >
                      {label}
                      <ArrowUpRight size={14} />
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-blue-deep text-cream py-16 grain relative">
        <div className="container-editorial relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="font-serif font-bold text-2xl md:text-3xl text-cream">
            One front door, <span className="italic text-amber-bright">two domains.</span>
          </p>
          <div className="flex flex-wrap gap-6">
            {CONTACT.domains.map((d) => (
              <span key={d} className="eyebrow text-[0.62rem] text-cream/60 flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-amber-bright rotate-45 inline-block" /> {d}
              </span>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
